import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/authentication/login.service';

@Component({
  selector: 'app-colaborators',
  templateUrl: './colaborators.component.html',
  styleUrls: ['./colaborators.component.css']
})
export class ColaboratorsComponent implements OnInit {

  	menu:any;
  	permissions = [];

	constructor(public auth: LoginService) { }

	ngOnInit() {
		this.menu = [
			{name:'Ventas', desc:'Módulo Ventas', icon:'fas fa-chart-line', url:'/sales', perm: 'SALES'},
			{name:'Logística', desc:'Módulo logístico', icon:'fas fa-truck', url:'/logistics', perm: 'LOGISTIC'}
		];

		this.auth.getPermissions().then(x => {
        this.permissions = x;
    });
	}

	hasPermission(str:string){
        if( this.permissions.indexOf(str) > -1 ){

            return true;
        }
        else{
            return false;
        }
    }

}
